export enum ResendErrorsEnum {
  alreadyVerified= 'already_verified',
  noUser = 'no_user',
  rateLimited = 'rate_limited',
  unknown = 'unknown',
  unknownUsername = 'unknown_username',
}
